import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isObject, isEmpty } from '@uswitch/ev-utils/lib/obj';
import { useExperiences } from '@uswitch/ev-utils/lib/context/selectors';
import { Experiment, Fallback } from '@uswitch/ev-utils/lib/experiments';
import { EVEntry } from '../../../entry';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var NA_FLAG_ID = 'not-applicable'; // Default not applicable flag ID

/**
 * @typedef {Object} Experience
 * @param {string} Experience.value The name of the cohort the user is in
 */

/**
 * @typedef {Object} Props
 * @param {string} experienceFlag The flag to switch the experience on
 * @param {any[]} experiencesList Ordered list of experiences IDs
 * @param {any[]} entityList The list of contentful entities to render
 * @param {Object.<string, Experience>} experiences List of experiences that the user is in
 * @param {Object.<string, string>} [entityMap] The list of contentful entities to render
 */

/**
 * Select
 * @param {Props} props - Same props as called by the `BaseExperienceEntitySelector'
 * @returns {Object}
 */

export var selectEntity = function selectEntity() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      experienceFlag = _ref.experienceFlag,
      _ref$experiences = _ref.experiences,
      experiences = _ref$experiences === void 0 ? {} : _ref$experiences,
      _ref$entityMap = _ref.entityMap,
      entityMap = _ref$entityMap === void 0 ? {} : _ref$entityMap,
      _ref$experienceList = _ref.experienceList,
      experienceList = _ref$experienceList === void 0 ? [] : _ref$experienceList,
      _ref$entityList = _ref.entityList,
      entityList = _ref$entityList === void 0 ? [] : _ref$entityList,
      _ref$fullPageTest = _ref.fullPageTest,
      fullPageTest = _ref$fullPageTest === void 0 ? false : _ref$fullPageTest;

  var experience = experiences[experienceFlag]; // This condition is for the URL contentType with multiple variants
  // e.g. full pages tests

  if (fullPageTest) {
    return entityList[(experience === null || experience === void 0 ? void 0 : experience.cohort) || 0];
  }

  var experienceValue = experience === null || experience === void 0 ? void 0 : experience.value; // Experience mapping based on mapping experienceFlag values to contentful
  // entity ids

  if (isObject(entityMap) && !isEmpty(entityMap)) {
    var entityId = entityMap[experienceValue] || entityMap[NA_FLAG_ID];
    return entityId ? {
      id: entityId
    } : null;
  } // Legacy experience mapping based on indexes


  var entityIndex = experienceList.findIndex(function (experience) {
    return experience === experienceValue;
  });
  return entityList[entityIndex] || entityList[0] || null;
};
/**
 * ExperienceEntitySelector
 *
 * Selects a contentful entity to render based on the experiences from chansey. The Fallback component
 * is used so that we can use custom rendering logic (selectEntity) rather than allowing Experiment
 * to decide what to render.
 *
 * @returns {*} The component to render
 */

var ExperienceEntitySelector = function ExperienceEntitySelector(props) {
  var experiences = useExperiences();
  var selectedEntity = selectEntity(_objectSpread(_objectSpread({}, props), {}, {
    experiences: experiences
  }));
  return _jsx(Experiment, {
    id: props.experienceFlag,
    children: selectedEntity ? _jsx(Fallback, {
      children: _jsx(EVEntry, _objectSpread({}, selectedEntity))
    }) : null
  });
};

export default ExperienceEntitySelector;